import { defineRecipe } from '@chakra-ui/react';

export const link = defineRecipe({
  className: 'chakra-link',

  variants: {
    variant: {
      plain: {
        fontWeight: 'semibold',
        color: 'blue.500',
        _dark: {
          color: 'link',
        },
      },
    },
  },
});
